import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { default as defaultQueryClient } from './query.config';
/**
 * CSS
 */

/**
 * Query PROVIDER for DYNAMIC configuration
 */
export interface QueryConfigProviderProps extends React.PropsWithChildren {
  devTools?: boolean;
}

export const QueryConfigProvider: React.FC<QueryConfigProviderProps> = ({
  devTools = false, // Keep it false for the tests, only enabled in app in DEV.
  children,
}) => {
  const [queryClient] = React.useState(() => defaultQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      {devTools && <ReactQueryDevtools initialIsOpen={false} />}
      {children}
    </QueryClientProvider>
  );
};
